//@ts-check
import * as THREE from "three";

/**
 * @module Clipping
 * @description New version of clipping logic Default use  
 * Set global clipActive true and call UpdateClipping() 
 */

// new version of clipping logic 
// Default use : set global clipActive true and call UpdateClipping() 
// other varibles clippingType (plane or box), clipLocal, clipIntersection
// TODO try to set watch event for clipActive, clippingType, clipLocal and clipIntersection otherwise manually call UpdateClipping

/**
 * Default use : set global clipActive true and call UpdateClipping() 
 * @param {string} modelID - modelId or canvas id 
 */
export function updateClipping(modelID) {
    var scope = this;
    for (let i = 0; i < scope.arrayOfModel.length; i++) {
        if (scope.arrayOfModel[i].name === modelID) {
            if (!scope.clipActive) {
                if (scope.clipLocal) {
                  scope.renderer.localClippingEnabled = false;
                } else {
                  scope.renderer.clippingPlanes = [];
                }
                //Restores all labels to their respective elements.
                scope.restoreLabels();
            }
            else {
                // populate scope.clippingPlanes 
                scope.addClippingPlanes();

                if (scope.clipLocal) // clip locally
                {
                    if (scope.stencilCap) {
                        // TODO testing needed - not quite working
                        scope.createStencil();
                    }
                    else {
                        // local clipping apply to elements
                        scope.elementsMap.forEach((child, name) => {
                            if (child instanceof THREE.Mesh && child.material) {
                                child.material.clippingPlanes = scope.clippingPlanes;
                                child.material.clipShadows = scope.clipShadows;
                                child.material.clipIntersection = scope.clipIntersection;
                            }
                            
                            // Check if the object is fully clipped and add isClipped property
                            child.isClipped = isObjectClipped(child);
                        })

                        // local clipping apply to edges
                        scope.edgesMap.forEach((child, name) => {
                            if (child instanceof THREE.LineSegments && child.material) {
                                child.material.clippingPlanes = scope.clippingPlanes;
                                child.material.clipShadows = scope.clipShadows;
                                child.material.clipIntersection = scope.clipIntersection;
                            }
                        })
                    }
                    scope.renderer.localClippingEnabled = true;
                    scope.renderer.clippingPlanes = [];

                } else { // clip globally

                    scope.renderer.localClippingEnabled = false;
                    scope.renderer.clippingPlanes = scope.clippingPlanes;
                }
            }
            // call clip Labels, method checks labelVariables array if not null applies clipping
            scope.clipLabels();
            scope.recalculateShadows();
        }
    }
}

function isObjectClipped(object){
  if (!object || !object.material) return false;

  // Check if clipping planes are present on the material
  const clippingPlanes = object.material.clippingPlanes;
  if (!clippingPlanes || clippingPlanes.length === 0) return false;

  // Get the object's bounding box
  const box = new THREE.Box3().setFromObject(object);

  // Check each clipping plane
  for (let plane of clippingPlanes) {
    // Check if all corners of the box are behind the plane
    const vertices = [
      new THREE.Vector3(box.min.x, box.min.y, box.min.z),
      new THREE.Vector3(box.min.x, box.min.y, box.max.z),
      new THREE.Vector3(box.min.x, box.max.y, box.min.z),
      new THREE.Vector3(box.min.x, box.max.y, box.max.z),
      new THREE.Vector3(box.max.x, box.min.y, box.min.z),
      new THREE.Vector3(box.max.x, box.min.y, box.max.z),
      new THREE.Vector3(box.max.x, box.max.y, box.min.z),
      new THREE.Vector3(box.max.x, box.max.y, box.max.z),
    ];

    // If all vertices are behind this plane, the object is clipped
    const allBehindPlane = vertices.every(vertex => plane.distanceToPoint(vertex) < 0);
    if (allBehindPlane) {
      return true;
    }
  }

  // If no plane fully clips the object, it is visible
  return false;
};

/**
 * Creates Stencil - Still working progress
 * : internal method
 * If global stencilCap is true, updateClipping() method calls this method
 */
export function createStencil() {
    var scope = this;
    scope.elementsMap.forEach((child, name) => {
        if (!(child instanceof THREE.Mesh) || !child.material) return;

        const object = new THREE.Group();
        scope.scene.add(object);

        const planeObjects = [];
        const planeGeom = new THREE.PlaneGeometry(400, 400);
        //planeGeom.rotateX(-Math.PI / 2); // Align with Z-up scene

        scope.clippingPlanes.forEach((plane, i) => {
            const poGroup = new THREE.Group();

            // Create stencil group for clipping
            const stencilGroup = createPlaneStencilGroup(child.geometry, plane, i + 1);
            object.add(stencilGroup);

            // Material for the clipped plane
            const planeMat = new THREE.MeshStandardMaterial({
                color: 0xE91E63,
                metalness: 0.1,
                roughness: 0.75,
                clippingPlanes: scope.clippingPlanes.filter(p => p !== plane),
                stencilWrite: true,
                stencilRef: 0,
                stencilFunc: THREE.NotEqualStencilFunc,
                stencilFail: THREE.ReplaceStencilOp,
                stencilZFail: THREE.ReplaceStencilOp,
                stencilZPass: THREE.ReplaceStencilOp,
            });

            const po = new THREE.Mesh(planeGeom, planeMat);
            po.renderOrder = i + 1.1;
            po.onAfterRender = () => {
                scope.renderer.clearStencil();
            };

            poGroup.add(po);
            planeObjects.push(po);
            scope.scene.add(poGroup);
        });

        // Update child material with clipping settings
        if (child.material) {
            child.material.clippingPlanes = scope.clippingPlanes;
            child.material.clipShadows = scope.clipShadows || false;
            child.material.clipIntersection = scope.clipIntersection || false;
        }

        // Add clipped color front mesh
        const clippedMaterial = new THREE.MeshStandardMaterial({
            color: 0xFFC107,
            metalness: 0.1,
            roughness: 0.75,
            clippingPlanes: scope.clippingPlanes,
            clipShadows: true,
            shadowSide: THREE.DoubleSide,
        });

        const clippedColorFront = new THREE.Mesh(child.geometry, clippedMaterial);
        clippedColorFront.castShadow = true;
        clippedColorFront.renderOrder = 6;
        object.add(clippedColorFront);
    });

}

/**
 * Creates Plane Stencil Group : internal method
 * @param {THREE.BufferGeometry} geometry 
 * @param {THREE.Plane} plane 
 * @param {Number} renderOrder 
 * @returns {Object} Return success or error messages 
 */
function createPlaneStencilGroup(geometry, plane, renderOrder) {
    const group = new THREE.Group();
    const baseMat = new THREE.MeshBasicMaterial({
        depthWrite: false,
        depthTest: false,
        colorWrite: false,
        stencilWrite: true,
        stencilFunc: THREE.AlwaysStencilFunc,
    });

    // Back faces
    const matBack = baseMat.clone();
    matBack.side = THREE.BackSide;
    matBack.clippingPlanes = [plane];
    matBack.stencilFail = THREE.IncrementWrapStencilOp;
    matBack.stencilZFail = THREE.IncrementWrapStencilOp;
    matBack.stencilZPass = THREE.IncrementWrapStencilOp;

    const meshBack = new THREE.Mesh(geometry, matBack);
    meshBack.renderOrder = renderOrder;
    group.add(meshBack);

    // Front faces
    const matFront = baseMat.clone();
    matFront.side = THREE.FrontSide;
    matFront.clippingPlanes = [plane];
    matFront.stencilFail = THREE.DecrementWrapStencilOp;
    matFront.stencilZFail = THREE.DecrementWrapStencilOp;
    matFront.stencilZPass = THREE.DecrementWrapStencilOp;

    const meshFront = new THREE.Mesh(geometry, matFront);
    meshFront.renderOrder = renderOrder;
    group.add(meshFront);

    return group;

}

/*
 
 ██████     ██          █████     ███    ██    ███████ 
 ██   ██    ██         ██   ██    ████   ██    ██      
 ██████     ██         ███████    ██ ██  ██    █████   
 ██         ██         ██   ██    ██  ██ ██    ██      
 ██         ███████    ██   ██    ██   ████    ███████ 
                                                                                                             
 
*/

// update clipping plane variables by axis
/**
 * Sets Clipping Axis (PLANE)
 * @param {string} dir - axis direction options: x,y or z
 * @param {Number} value - value between 0 to 1
 * @param {boolean} flip - flipped clipping direction
 * @param {boolean} active - active
 */
export function setClippingAxis(dir, value, flip, active) {
    var scope = this;
    const direction = scope.clipDirections.find(item => item.key === dir);
    if (direction) Object.assign(direction, { value, flip, active });
}

/*
 
 ██████      ██████     ██   ██ 
 ██   ██    ██    ██     ██ ██  
 ██████     ██    ██      ███   
 ██   ██    ██    ██     ██ ██  
 ██████      ██████     ██   ██ 
                                
                                
*/

// update clipping plane variables by axis
/**
 * Sets Clipping Direction (BOX) 
 * @param {string} dir - axis direction options: x,y or z
 * @param {Array<Number>} valueRange - Values Ranged 0 to 1 min: valueRange[0] , max: valueRange[1]
 * @param {boolean} active - active 
 */
export function setClippingDirection(dir, valueRange, active) {
    var scope = this;
    const direction = scope.clipDirections.find(item => item.key === dir);
    if (direction) Object.assign(direction, { valueRange, active, min: valueRange[0], max: valueRange[1] });
}

/**
 * Creates clipping plane and adds global Clipping planes array
 * @param {string} dir - direction : Option x, y, z
 * @param {Number} value  - value should be actual value not 0-1
 * @param {boolean} flip - flip true or false ?
 */
export function addClippingPlane(dir, value, flip) {
    var scope = this;

    var pt = new THREE.Vector3(0, 0, 0);
    pt[dir] = flip ? 1 : -1;
    value = flip ? -1 * value : value;

    var clipPlane = new THREE.Plane(pt, value);

    scope.clippingPlanes.push(clipPlane);

}

/**
 * Populates global Clipping Planes per clipping planes settings 
 */
export function addClippingPlanes() {
    var scope = this;

    scope.clippingPlanes = [];

    const box = scope.boundingBox;

    if (scope.clippingType == 'plane') {
        // max total 3 planes if all active
        scope.clipDirections.forEach((clipDirection) => {
            if (clipDirection.active) {
                //Adjust values so that 0 or 1 values doesn't accidently clip an edge
                let adjustedValue = clipDirection.value;
                if (adjustedValue === 1) {
                    adjustedValue = 1.01;
                } else if (adjustedValue === 0) {
                    adjustedValue = -0.01;
                }
                let length = box.max[clipDirection.key] - box.min[clipDirection.key]
                let value = box.min[clipDirection.key] + length * adjustedValue
                scope.addClippingPlane(clipDirection.key, value, clipDirection.flip)
            }
        })
    }
    else { //else clippig type box
        // total 6 planes 
        scope.clipDirections.forEach((clipDirection) => {
          if(clipDirection.active){
            // Adjust min and max values if they're exactly 0 or 1 to prevent accidental clipping
            let adjustedMin = Number(clipDirection.min);
            if (adjustedMin === 0) adjustedMin = -0.01;
            let adjustedMax = Number(clipDirection.max);
            if (adjustedMax === 1) adjustedMax = 1.01;

            let length = box.max[clipDirection.key] - box.min[clipDirection.key];

            let minValue = box.min[clipDirection.key] + length * adjustedMin
            let maxValue = box.min[clipDirection.key] + length * adjustedMax

            scope.addClippingPlane(clipDirection.key, minValue, true)
            scope.addClippingPlane(clipDirection.key, maxValue, false)
          }
        })

    }

}
